var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewCaution(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3001 12.9968L6.06674 60.1301C5.48463 61.1382 5.17663 62.2811 5.17337 63.4452C5.17011 64.6093 5.47171 65.7539 6.04816 66.7652C6.62461 67.7765 7.45582 68.6193 8.4591 69.2096C9.46237 69.8 10.6027 70.1173 11.7667 70.1301H68.2334C69.3974 70.1173 70.5378 69.8 71.541 69.2096C72.5443 68.6193 73.3755 67.7765 73.952 66.7652C74.5284 65.7539 74.83 64.6093 74.8268 63.4452C74.8235 62.2811 74.5155 61.1382 73.9334 60.1301L45.7001 12.9968C45.1058 12.0172 44.2691 11.2072 43.2707 10.6451C42.2723 10.083 41.1459 9.78766 40.0001 9.78766C38.8543 9.78766 37.7278 10.083 36.7294 10.6451C35.731 11.2072 34.8943 12.0172 34.3001 12.9968Z",
    stroke: "#FFA800",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30.1301V43.4635",
    stroke: "#FFA800",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56.7968H40.0333",
    stroke: "#FFA800",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCaution);
export default __webpack_public_path__ + "static/media/newCaution.2c8ca99672a7eacaec7dd6236ae0143d.svg";
export { ForwardRef as ReactComponent };